<template>
  <div class="prohibited-wrapper">
    <div class="search-wrapper">
        <van-search
        v-model="ajaxJson.keyword"
        placeholder="请输入搜索关键词"
        class="search"
        @search="goContent"
      />
      <van-button
        type="info"
        @click="goContent"
      >
        搜索
      </van-button>
    </div>
    <div class="explain">
      <p>说明：</p>
      <p class="exlain-textin"><span>1、</span><span>违禁词库无法包含所有违禁词，词库未包含词语，需结合含义及使用场景判断。</span></p>
      <p class="exlain-textin"><span>2、</span><span>违禁词库中部分词语，结合证明、特定场景可使用，具体请跟法务确认。</span></p>
    </div>
    <!-- <van-divider content-position="left">列表</van-divider> -->
    <div v-if="contentData.data && contentData.data.length">
      <div v-if="!searchData.length">
        <van-cell class="cell-list" :value="item.keyword" v-for="(item, index) in contentData.data" :key="index" />
      </div>
      <div v-else>
        <div v-for="(item, index) in searchData" :key="index" class="cell-list">
          <span v-for="(items, indexs) in item" :key="indexs">{{items}}<span v-if="indexs !== (item.length - 1)" class="add-color">{{ addColorWord }}</span>
          </span>
        </div>
      </div>
      <van-divider
        :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
      >
        到底啦
      </van-divider>
    </div>
    <div v-else>
      <van-divider
        :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
      >
        暂无数据
      </van-divider>
    </div>
  </div>
</template>

<script>
import { goGet } from '@/utils/public'
export default {
  data() {
    return {
      ajaxJson: {
        keyword: '',
        page: 15,
        pageId: 1,
        key: 'all'
      },
      domain: process.env.VUE_APP_TAPI_API,
      contentData: {},
      searchData: [],
      addColorWord: ''
    }
  },

  mounted () {
    this.goContent()
  },

  methods: {
    goContent() {
      this.ajaxJson.key = this.ajaxJson.keyword === '' ? 'all' : this.ajaxJson.keyword
      goGet(this.domain + '/api/v2/bi/violate/get_word', this.ajaxJson).then(res => {
        this.contentData = res.data
        this.ajaxJson.keyword !== '' ? this.resSearch() : this.searchData = []
      })
    },
    resSearch() {
      // 处理搜索结果
      this.addColorWord = this.ajaxJson.keyword
      this.searchData = this.contentData.data.map(ele => {
        return ele.keyword.split(this.ajaxJson.keyword)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .prohibited-wrapper {
    min-height: 100vh;
    overflow: hidden;
    padding-bottom: 20px;
    box-sizing: border-box;
    width: 100%;
    .search-wrapper {
      display: flex;
      align-items: center;
      padding: 10px 12px;
      box-sizing: border-box;
      justify-content: space-between;
      .search {
        overflow: hidden;
        padding: 0;
        width: 285px;
      }
      .van-button {
        height: 33px;
        line-height: 33px;
        width: 60px;
        padding: 0;
        text-align: center;
      }
    }
    .explain {
      width: 100%;
      padding: 10px 20px;
      background: #f8f8f8;
      font-size: 12px;
      line-height: 20px;
      color: #929292;
      .exlain-textin {
        padding-left: 22px;
        box-sizing: border-box;
        display: flex;
      }
    }
    .cell-list {
      border-bottom: 1px solid #e6e6e6;
      font-size: 14px;
      color: #323233;
      padding: 10px 16px;
      line-height: 24px;
      overflow: hidden;
      .add-color {
        color: #1989fa;
      }
      &:nth-last-child(1) {
        border: 0;
      }
      &:nth-child(2n) {
        background: rgba(25, 137, 250, 0.05);
      }
      &::after {
        display: none;
      }
    }
  }
</style>
